// External libraries
import React from 'react';
import styled from 'styled-components';

// Icon code
import { Icon } from './_base';

const CalendarSVG = styled(Icon).attrs({ viewBox: '0 0 36 33' })``;

function Calendar({ color = 'currentColor', ...props }) {
    return (
        <CalendarSVG data-test="icon-calendar" {...props}>
            <g fill="none" fillRule="nonzero">
                <path d="M1.5 4.5h33v27h-33z" stroke={color} strokeWidth="3" />
                <path
                    d="M8 0h3v8H8zM7 13h4v4H7zM16 13h4v4h-4zM25 13h4v4h-4zM7 21h4v4H7zM16 21h4v4h-4zM25 21h4v4h-4zM25 0h3v8h-3z"
                    fill={color}
                />
            </g>
        </CalendarSVG>
    );
}
const CalendarSmallSVG = styled(Icon).attrs({
    viewBox: '0 0 16 16',
    width: 16,
    height: 16,
})``;

function CalendarSmall({ color = 'currentColor', ...props }) {
    return (
        <CalendarSmallSVG {...props}>
            <path
                fill={color}
                fillRule="nonzero"
                d="M11.2 1.6V.8A.8.8 0 0 1 12 0h.8a.8.8 0 0 1 .8.8v.8A2.4 2.4 0 0 1 16 4v9.6a2.4 2.4 0 0 1-2.4 2.4H2.4A2.4 2.4 0 0 1 0 13.6V4a2.4 2.4 0 0 1 2.4-2.4V.8a.8.8 0 0 1 .8-.8H4a.8.8 0 0 1 .8.8v.8h6.4zM1.6 4.8v8.8a.8.8 0 0 0 .8.8h11.2a.8.8 0 0 0 .8-.8V4.8H1.6z"
            />
        </CalendarSmallSVG>
    );
}

export { Calendar as default, Calendar, CalendarSmall };
